import * as actionTypes from "../actionTypes"

const defaultState = {
  id: "",
  firstName: "",
  availabilityStatus: null,
  lastName: "",
  email: "",
  authorized: false,
  tcAcknowledgementPending: false,
  smAcknowledgementPending: false
}

const userReducer = (state = defaultState, action: UserAction) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        authorized: true,
        id: action.user.id,
        email: action.user.email,
        firstName: action.user.firstName,
        availabilityStatus: action.user.availabilityStatus,
        lastName: action.user.lastName,
        tcAcknowledgementPending: action.user.tcAcknowledgementPending,
        smAcknowledgementPending: action.user.smAcknowledgementPending
      }
    case actionTypes.LOGOUT_USER:
      return {
        id: "",
        firstName: "",
        availabilityStatus: null,
        lastName: "",
        email: "",
        authorized: false,
        tcAcknowledgementPending: false,
        smAcknowledgementPending: false
      }
    default:
      return state
  }
}

export default userReducer
